<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <v-select
          class="col-lg-3 col-md-3 m-b-xs" placeholder="Name"
          :options="orders.map(order => order.name)"
          v-model="ordersFilters.name"
        ></v-select>
        <v-select
          class="col-lg-3 col-md-3 m-b-xs" placeholder="Client"
          :options="orders.map(order => order.client)"
          label="name" index="id"
          v-model="ordersFilters.client"
        ></v-select>
        <v-select
          class="col-lg-3 col-md-3 m-b-xs" placeholder="Status"
          :options="orders.map(order => order.status)"
          v-model="ordersFilters.status"
        ></v-select>
      </div>
    </div>
    <div class="col-lg-12 m-t-md">
      <table class="table table-hover">
      <thead>
      <tr>
        <th>Name</th>
        <th>Client</th>
        <th>Start</th>
        <th>Credits</th>
        <th class="center" v-tooltip="'Completed Tasks'"><i class="fa fa-check green"></i></th>
        <th class="center" v-tooltip="'Assigned Tasks'"><i class="fas fa-user-clock teal"></i></th>
        <th class="center" v-tooltip="'Tasks Waiting'"><i class="fa fa-clock orange"></i></th>
        <th>Status</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="order in ordersTable" :key="order.id">
        <td><router-link :to="`/maintenance/order/${order.id}`">{{ order.name }}</router-link></td>
        <td>{{ order.client.name }}</td>
        <!-- no available data for this client - page does not load
        <td>
          <router-link :to="'/ppc/client/' + order.client.id">{{ order.client.name }}</router-link>
        </td>-->
        <td>{{ order.start | aTime('DD.MM.YYYY') }}</td>
        <td>{{ order.credits }}</td>
        <td align="center"><span class="green">{{ order.taskCounts.completed || 0 }}</span></td>
        <td align="center"><span class="teal">{{ order.taskCounts.assigned || 0 }}</span></td>
        <td align="center"><span class="orange">{{ order.taskCounts.created || 0 }}</span></td>
        <td>{{ order.status }}</td>
      </tr>
      </tbody>
    </table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      ordersFilters: {}
    }
  },
  mounted () {
    if (!this.orders.length) {
      this.$store.dispatch('loadMaintenanceOrders', 'status=open')
    }
  },
  computed: {
    ...mapGetters({
      orders: 'getMaintenanceOrders'
    }),
    ordersTable () {
      let newOrders = this.orders
      if (this.ordersFilters.name) {
        newOrders = newOrders.filter(newOrders.name === this.ordersFilters.name)
      }
      if (this.ordersFilters.client) {
        newOrders = newOrders.filter(newOrders.client.id === this.ordersFilters.client)
      }
      if (this.ordersFilters.status) {
        newOrders = newOrders.filter(newOrders.status === this.ordersFilters.status)
      }
      return newOrders
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/MaintenanceOrder/List.vue